// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"v26.45.3"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import { isNextPublicSentryEnabled } from '@/utils/is-next-public-sentry-enabled';
import * as Sentry from '@sentry/nextjs';

Sentry.init({
  enabled: isNextPublicSentryEnabled(),
  environment:
    process.env.NODE_ENV === 'production' ? 'production' : 'development',
  dsn: 'https://9d3f3d540c82273edb0c86375605742a@o408588.ingest.us.sentry.io/4506995742736384',
  release: process.env.NEXT_PUBLIC_VERSION,

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  replaysOnErrorSampleRate: 0,

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0,
});
